import { useEffect, type RefObject } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToTop = (containerRef?: RefObject<HTMLElement | null>) => {
  const location = useLocation();

  useEffect(() => {
    if (containerRef?.current) {
      containerRef.current.scrollTo({ top: 0, behavior: 'auto' });
    } else {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [location.pathname, location.search]);
};

export default useScrollToTop;
